/** Reads `REACT_APP_WHATSAPP_NUMBER`; returns digits-only E.164 or "". */
export function getWhatsAppE164FromEnv() {
  const raw = process.env.REACT_APP_WHATSAPP_NUMBER;
  if (raw == null || String(raw).trim() === "") return "";
  return String(raw).replace(/\D/g, "");
}

export function buildWhatsAppInquiryUrl(fields, whatsappE164) {
  const { fullName, email, mobile, subject, message } = fields;
  const body = [
    "New inquiry from the Altus Online School website contact form:",
    "",
    `Name: ${fullName}`,
    `Email: ${email}`,
    `Mobile: ${mobile}`,
    `Subject: ${subject.trim() || "—"}`,
    "",
    "Message:",
    message,
  ].join("\n");

  const maxChars = 1800;
  const text =
    body.length > maxChars ? `${body.slice(0, maxChars - 3).trimEnd()}...` : body;

  return `https://wa.me/${whatsappE164}?text=${encodeURIComponent(text)}`;
}

/** Opens wa.me with the inquiry; returns `{ ok: false }` if env number is missing. */
export function openContactInquiryWhatsApp(fields) {
  const e164 = getWhatsAppE164FromEnv();
  if (!e164) {
    return { ok: false, reason: "missing_number" };
  }
  const url = buildWhatsAppInquiryUrl(fields, e164);
  window.open(url, "_blank", "noopener,noreferrer");
  return { ok: true };
}
